import React from "react";
import { HeaderConfig, appliedConfig } from "../config/commonConfig";

function Pricing() {
  return (
    <section
      id="pricing"
      className={
        "section bg-light " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div className="container">
        <p className="lead text-center mb-4">
          <b>Фото його автомобіля біля будинку, де він живе з дружиною Марією.</b>
        </p>
        <div className="row">
          <div class="col-md-4"></div>
          <div class="col-md-4 col-sm-12">
            <img className="img-fluid" alt="" src="images/image6.jpg" />
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
